import React, { useState } from 'react';
import { Box, Typography, IconButton, Divider, Grid, Button } from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import useStyles from './styles';

const CommandPayload = (properties: any) => {
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();
  const {
    command: { commandType, state, priority, fileType, commandBody, commandLocation ,status , statusMessage , errorMessage},
    downloadFile
  } = properties;

  const handleToggleExpanded = () => {
    properties.updateHeight();
    setExpanded(!expanded);
  };

  return (
    <Box pb={1} width="100%">
      <Divider />
      <Box pt={1} display="flex" alignItems="center">
        <Box pr={1}>
          <Box>
            <Typography variant="h6">Payload </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={handleToggleExpanded}
          aria-label="expand"
          style={{ width: '1rem', height: '1rem', marginRight: '1rem' }}
          size="large">
          {expanded ? <ExpandMore /> : <ChevronRight />}
        </IconButton>
      </Box>
      {expanded && (
        <Box>
          <Grid container>
            <Grid item xs={3}>
              <Box display="flex">
                <Box>
                  <Typography>Command Type: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{commandType}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box display="flex">
                <Box>
                  <Typography>State: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{state}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box display="flex">
                <Box>
                  <Typography>Priority: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{priority}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box display="flex">
                <Box>
                  <Typography>File Type: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{fileType}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={3} pt={1}>
              <Box display="flex">
                <Box>
                  <Typography>Command Status: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{status}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={!errorMessage ? 9 : 3 } pt={1}>
              <Box display="flex">
                <Box>
                  <Typography>Status Message: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{statusMessage}</Typography>
                </Box>
              </Box>
            </Grid>
            {errorMessage && <Grid item xs={6} pt={1}>
              <Box display="flex">
                <Box>
                  <Typography>Error Message: </Typography>
                </Box>
                <Box ml={1}>
                  <Typography variant="h6">{errorMessage}</Typography>
                </Box>
              </Box>
            </Grid>
            }   
            <Grid item xs={1} pt={1}>
              <Box pt={1}>
                <Typography>Command Body: </Typography>
              </Box>
            </Grid>
            <Grid item xs={11} pt={1}>
              <Box pt={1} component="div" className={classes.commandBody}>
                <Typography variant="h6">
                  {commandType === 6 ? commandLocation : commandBody}
                </Typography>
              </Box>
            </Grid>
            {commandType === 6 && (
              <Grid item xs={12} pt={1}>
                <Button variant="outlined" onClick={downloadFile}>
                  <Typography variant="button">Download</Typography>
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default CommandPayload;
